module.exports = __webpack_public_path__ + "img/other.3d675a1a.jpg";